import { createContext } from 'react';
import { ReactNode } from 'react';
import { useContext, useEffect, useState } from 'react';
import { ServicesContext } from 'app/items/shared/context_interface';

interface TerrainModeContextType {
    terrainEnabled: boolean;
}

export const TerrainModeContext = createContext<TerrainModeContextType>({ terrainEnabled: false });

export const TerrainModeProvider = ({ children }: { children: ReactNode }) => {
    const { mapService } = useContext(ServicesContext);
    const [terrainEnabled, setTerrainEnabled] = useState<boolean>(
        mapService.viewer.terrainProvider.hasVertexNormals,
    );

    useEffect(() => {
        const updateTerrainEnabled = () => {
            setTerrainEnabled(mapService.viewer.terrainProvider.hasVertexNormals);
        };

        mapService.viewer.scene.terrainProviderChanged.addEventListener(updateTerrainEnabled);

        return () => {
            mapService.viewer.scene.terrainProviderChanged.removeEventListener(
                updateTerrainEnabled,
            );
        };
    }, [
        mapService.viewer.scene.terrainProviderChanged,
        mapService.viewer.terrainProvider.hasVertexNormals,
    ]);

    return (
        <TerrainModeContext.Provider value={{ terrainEnabled }}>
            {children}
        </TerrainModeContext.Provider>
    );
};
